export const extractCharBetween = (target: string, start: string, end: string) => {
  const startIndex = target.indexOf(start);
  const endIndex = target.indexOf(end);

  if (startIndex === -1 || endIndex === -1) return '';

  return target.slice(startIndex + start.length, endIndex);
};
